import FormValidator from './formvalidator';

class FormList {
  constructor() {
    this.formClass = 'formbuilder';
    this.formElements = document.querySelectorAll(`form.${this.formClass}`);
    this.formList = [];
  }

  init() {
    // INIT FORMS LIST
    this.formElements.forEach((form, index) => {
      this.formList[index] = new FormValidator(form, true);
    });
  }
}

const fl = new FormList();
fl.init();
